import {
  PlayArrow as StartIcon,
  Pause as PauseIcon,
  Stop as StopIcon,
} from '@mui/icons-material';

/**
 * Get available status actions for an experiment.
 *
 * @param {Object} experiment - Experiment object
 * @param {Array} experiments - All experiments (for checking active experiments)
 * @returns {Array} Array of action objects
 */
export function getStatusActions(experiment, experiments) {
  const actions = [];

  switch (experiment.status) {
    case 'draft':
      // Check if template already has an active experiment
      const hasActiveExperiment = experiments.some(
        exp =>
          exp.template_id === experiment.template_id &&
          exp.id !== experiment.id &&
          exp.status === 'active'
      );
      actions.push({
        label: 'Start Experiment',
        action: 'start',
        icon: <StartIcon />,
        disabled: hasActiveExperiment,
        tooltip: hasActiveExperiment
          ? 'This template already has an active experiment. Please stop or pause it first.'
          : null,
      });
      break;
    case 'active':
      actions.push({
        label: 'Pause Experiment',
        action: 'pause',
        icon: <PauseIcon />,
      });
      actions.push({
        label: 'Stop Experiment',
        action: 'stop',
        icon: <StopIcon />,
      });
      break;
    case 'paused':
      // Check if template already has an active experiment
      const hasActiveExperimentPaused = experiments.some(
        exp =>
          exp.template_id === experiment.template_id &&
          exp.id !== experiment.id &&
          exp.status === 'active'
      );
      actions.push({
        label: 'Resume Experiment',
        action: 'resume',
        icon: <StartIcon />,
        disabled: hasActiveExperimentPaused,
        tooltip: hasActiveExperimentPaused
          ? 'This template already has an active experiment. Please stop or pause it first.'
          : null,
      });
      actions.push({
        label: 'Stop Experiment',
        action: 'stop',
        icon: <StopIcon />,
      });
      break;
    default:
      break;
  }

  return actions;
}
